module.exports = __webpack_public_path__ + "static/media/chantal.bd03c5be.jpg";